module.exports = __webpack_public_path__ + "fonts/fa-solid-900.149d83e172c5a4b855ac26fcf41f3d74.ttf";